module.exports = __webpack_public_path__ + "img/question.b0caae62.png";